<template>
<div class="body">
  <div class="pdf-wrapper">
    <div class="container">
      <header style="display: flex;align-items: flex-start;justify-content: space-between" class="no-margin">
        <div>
          <img src="./img/Logos_TXT.svg" alt="" class="logo">
          <div class="logo-text">
            App for collecting and analysing sport videos using Machine Learning algorithm.
          </div>
        </div>
        <img src="./img/Logo_acronis.svg" alt="">
      </header>
      <div class="page-row mt-30">
        <div class="side-content">
          <div>
            <div class="content-heading">PARAMETERS</div>
            <div class="formula-row mt-10">
              <div class="formula-char">L</div>
              <span>Full video duration</span>
            </div>
            <div class="formula-row">
              <div class="formula-char">T</div>
              <span>Brand exposure time</span>
            </div>
            <div class="formula-row">
              <div class="formula-char">W</div>
              <span>Horizontal video resolution</span>
            </div>
            <div class="formula-row">
              <div class="formula-char">H</div>
              <span>Vertical video resolution</span>
            </div>
            <div class="formula-row">
              <div class="formula-char">S</div>
              <span>Brand logo area averaged over full length of video</span>
            </div>
          </div>
        </div>
        <div class="main-content">
          <div class="content-heading">HEATMAP  DESCRIPTION</div>
          <div class="heatmap-story-row">
            <img src="./img/rainbow.png" alt="" class="heatmap-gradient no-margin-x">
            <div class="arrows"></div>
            <div>
              <div class="more">MORE FREQUENTLY</div>
              <div class="less">LESS FREQUENTLY</div>
            </div>
            <span class="para2">Heatmaps provide a quick visual way to analyze the screen location of brand logo area exposure across an entire video. The parts of a frame where a brand logo appears more frequently (i.e. high exposure areas) are colored red (hot) and conversely, the parts of the video where a brand logo appears infrequently are colored blue (cool).</span>
          </div>
        </div>
      </div>
      <div class="page-row mt-25">
        <div class="side-content">
          <div>
            <div class="content-heading">EXPOSURE TIME, s</div>
            <div class="math">
              Te =
              <table style="display:inline-table; border-collapse:collapse; vertical-align:middle">
                <tbody>
                <tr>
                  <td style="padding:0px; border-bottom: solid 1px; width:8px; text-align:center">T</td>
                </tr>
                <tr>
                  <td style="padding:0px; text-align:center">L</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="main-content">
          <div class="content-heading">PARAMETER DESCRIPTION</div>
          <div class="para">
            EXPOSURE TIME, s —  absolute total time in seconds that the brand was on the screen.

          </div>
        </div>
      </div>
      <div class="page-row mt-25">
        <div class="side-content">
          <div>
            <div class="content-heading">EXPOSURE TIME, %</div>
            <div class="math">
              Te =
              <table style="display:inline-table; border-collapse:collapse; vertical-align:middle">
                <tbody>
                <tr>
                  <td style="padding:0px; border-bottom: solid 1px; width:8px; text-align:center">T</td>
                </tr>
                <tr>
                  <td style="padding:0px; text-align:center">L</td>
                </tr>
                </tbody>
              </table>
              * 100%
            </div>
          </div>
        </div>
        <div class="main-content">
          <div class="content-heading">&nbsp;</div>
          <div class="para">
            EXPOSURE TIME, % —  percentage time (relative to the total video duration) that the brand was on the screen.

          </div>
        </div>
      </div>
      <div class="page-row mt-25">
        <div class="side-content">
          <div>
            <div class="content-heading">MEAN AREA, %</div>
            <div class="math">
              A =
              <table style="display:inline-table; border-collapse:collapse; vertical-align:middle">
                <tbody>
                <tr>
                  <td style="padding:0px; width:8px; text-align:center"></td>
                  <td style="padding:0px; width:8px; text-align:center">S</td>
                  <td style="padding:0px; width:8px; text-align:center"></td>
                </tr>
                <tr>
                  <td style="padding:0px; border-top: solid 1px; text-align:center"><span>W</span></td>
                  <td style="padding:0px; border-top: solid 1px;text-align:center"><span>*&nbsp;</span></td>
                  <td style="padding:0px; border-top: solid 1px;text-align:center"><span>H</span></td>
                </tr>
                </tbody>
              </table>
              * 100%
            </div>
          </div>
        </div>
        <div class="main-content">
          <div class="content-heading">&nbsp;</div>
          <div class="para">
            MEAN AREA, % — brand logo area averaged over full length of video, relative to full video size

          </div>
        </div>
      </div>
      <div class="page-row mt-25">
        <div class="side-content">
          <div>
            <div class="content-heading">BIS</div>
            <div class="para">
              <p>BIS = multiplication of the following impact factors: </p>
              <ul>
                <li>Number of brands</li>
                <li>Brand screen position</li>
                <li>Brand screen coverage</li>
                <li>Brand screen duration</li>
                <li>Brand instance visibility</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="main-content">
          <div class="content-heading">&nbsp;</div>
          <div class="page-row" style="margin-bottom: 20px">
            <div class="para">
              BIS (Brand impact score) - custom metric that depends on whether there is one brand on the screen or not, how many instances of one brand are on the screen, how long the brand has been on the screen in a row.
            </div>
            <div class="para2">
              Example:<br>
              Brand is not ‘Solus’ = 1.0  (no multiplication, multiplication when solus, solus means there is only 1 brand on the screen)
              Centre of brand is in centre 50% = 1.1
              Brand covers 0-5% of the screen = 1.0
              Brand is on screen for 2-5 secs = 1.05
              1 instance of brand is visible = 1.0 (multiple instances gives multiplication)

              <p>
                TOTAL 1.0 x 1.1 x 1.0 x 1.05 x 1.0 1.155
                BRAND IMPACT SCORE = 1.55
              </p>

              Higher BIS value is better.

            </div>
          </div>
        </div>
      </div>
      <div class="pdf-footer">
        <span></span>
        <span>Page 3 / 3</span>
      </div>
    </div>
  </div>

</div>
</template>

<script>
    export default {
        name: "report-description"
    }
</script>

<style scoped>
  /* --------------------------------------------------------------

   typography.css
   * Sets up some sensible default typography.
   http://www.blueprintcss.org/blueprint/src/typography.css
-------------------------------------------------------------- */

  /* Default font persons.
     The font-size percentage is of 16px. (0.75 * 16px = 12px) */

  html { font-size:100.01%; }
  body, .body {
    font-size: 75%;
    color: #222;
    background: #fff;
    font-family: "AcronisCyber", "Helvetica Neue", Arial, Helvetica, sans-serif;
    box-sizing: unset;
  }


  /* Headings
  -------------------------------------------------------------- */

  h1,h2,h3,h4,h5,h6 { font-weight: bold; font-family: "AcronisCyberBold", sans-serif}

  h1 { font-size: 3em; line-height: 1; margin-bottom: 0.5em; }
  h2 { font-size: 2em; margin-bottom: 0.75em; }
  h3 { font-size: 1.5em; line-height: 1; margin-bottom: 1em; }
  h4 { font-size: 1.2em; line-height: 1.25; margin-bottom: 1.25em; }
  h5 { font-size: 1em; font-weight: bold; margin-bottom: 1.5em; }
  h6 { font-size: 1em; font-weight: bold; }

  h1 img, h2 img, h3 img,
  h4 img, h5 img, h6 img {
    margin: 0;
  }


  /* Text elements
  -------------------------------------------------------------- */

  p           { margin: 0 0 1.5em; }
  /*
      These can be used to pull an image at the start of a paragraph, so
      that the text flows around it (usage: <p><img class="left">Text</p>)
   */
  .left  			{ float: left !important; }
  p .left			{ margin: 1.5em 1.5em 1.5em 0; padding: 0; }
  .right 			{ float: right !important; }
  p .right 		{ margin: 1.5em 0 1.5em 1.5em; padding: 0; }

  a:focus,
  a:hover     { color: #09f; }
  a           { color: #06c; text-decoration: underline; }

  blockquote  { margin: 1.5em; color: #666; font-style: italic; }
  strong,dfn	{ font-weight: bold; }
  em,dfn      { font-style: italic; }
  sup, sub    { line-height: 0; }

  abbr,
  acronym     { border-bottom: 1px dotted #666; }
  address     { margin: 0 0 1.5em; font-style: italic; }
  del         { color:#666; }

  pre         { margin: 1.5em 0; white-space: pre; }
  pre,code,tt { font: 1em 'andale mono', 'lucida console', monospace; line-height: 1.5; }


  /* Lists
  -------------------------------------------------------------- */

  li ul,
  li ol       { margin: 0; }
  ul, ol      { margin: 0 1.5em 1.5em 0; padding-left: 1.5em; }

  ul          { list-style-type: disc; }
  ol          { list-style-type: decimal; }

  dl          { margin: 0 0 1.5em 0; }
  dl dt       { font-weight: bold; }
  dd          { margin-left: 1.5em;}


  /* Tables
  -------------------------------------------------------------- */

  /*
      Because of the need for padding on TH and TD, the vertical rhythm
      on table cells has to be 27px, instead of the standard 18px or 36px
      of other elements.
   */
  /*table       { margin-bottom: 1.4em; width:100%; }*/
  /*th          { font-weight: bold; text-align: center }*/
  /*thead th    { background: #c3d9ff; }*/
  /*th,td,caption { padding: 4px 10px 4px 5px; }*/
  /*
      You can zebra-stripe your tables in outdated browsers by adding
      the class "even" to every other table row.
   */
  /*tbody tr:nth-child(even) td,*/
  /*tbody tr.even td  {*/
  /*background: #e5ecf9;*/
  /*}*/
  /*tfoot       { font-style: italic; }*/
  /*caption     { background: #eee; }*/

  /* Misc classes
  -------------------------------------------------------------- */

  .small      { font-size: .8em; margin-bottom: 1.875em; line-height: 1.875em; }
  .large      { font-size: 1.2em; line-height: 2.5em; margin-bottom: 1.25em; }
  .hide       { display: none; }

  .quiet      { color: #666; }
  .loud       { color: #000; }
  .highlight  { background:#ff0; }
  .added      { background:#060; color: #fff; }
  .removed    { background:#900; color: #fff; }

  .first      { margin-left:0; padding-left:0; }
  .last       { margin-right:0; padding-right:0; }
  .top        { margin-top:0; padding-top:0; }
  .bottom     { margin-bottom:0; padding-bottom:0; }

  body, html, .body {
    box-sizing: unset;
    padding: 0;
    height: 860px;
    /*transform: scale(1.15);*/
  }

  .body {
    /*margin: 0 auto;*/
    /*margin-top: 10%;*/
  }

  .math {
    margin-top: 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 12px !important;
    line-height: 15px;
    color: #00204D;
  }

  svg {
    transform: translateX(-3.4%) scale(1.11);
  }

  header {
    border-top: 0.5px solid #00204D;
    padding-top: 10px;
    display: flex;
    margin-bottom: 120px;
  }

  .pdf-footer {
    position: absolute;
    bottom: 0;
    padding-bottom: 10px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    border-bottom: 0.5px solid #00204D;
  }

  section {
    display: flex;
  }

  span, h3, th, td, div {
    font-style: normal;
    font-weight: normal;
    font-size: 8px;
    line-height: 11px;
    color: #00204D;
    text-align: left;
  }

  th {
    margin-right: 10px;
  }

  .table-cell {
    text-align: center;
    font-style: normal;
    font-weight: normal;
    font-size: 8px;
    line-height: 11px;
    color: #00204D;
    flex: none;
    order: 1;
    flex-grow: 0;
    margin-right: 10px;
  }

  h3 {
    font-weight: bold;
    margin: 0;
  }

  h1 {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 20px;
    color: #00204D;
    margin: 0;
    width: 340px;
    word-break: break-word;
  }

  .table-row {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding-bottom: 9px;

    position: static;
    width: 340px;
    height: 11px;
    left: 0px;
    top: 0px;

    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 9px 0px;

    border-bottom: 0.5px solid #00204D;

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .no-border {
    border: none;
    height: 11px;
  }

  .no-padding {
    padding: 0;
  }

  .pt-20 {
    padding-top: 20px;
  }

  .mt-45 {
    margin-top: 45px;
  }

  .mt-30 {
    margin-top: 30px;
  }

  .mt-25 {
    margin-top: 25px;
  }

  .mt-10 {
    margin-top: 10px;
  }

  .no-margin {
    margin: 0;
  }

  .container {
    position: relative;
    width: 510px;
    height: 780px;
    background: #FFFFFF;
    margin: 0 auto;
  }

  .pdf-wrapper {
    position: relative;
    width: 593px;
    background: #FFFFFF;
    margin: 0 auto;
    padding: 30px 0;
  }

  .date {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    color: #00204D;
    margin: 0;
    margin-bottom: 10px;
  }

  .side-content {
    width: 150px;
    margin-right: 20px;
  }

  .side-content-2 {
    width: 320px;
    margin-right: 20px;
  }

  .main-content-2 {
    width: 170px;
    box-sizing: unset;
  }

  .main-content {
    width: 340px;
  }

  .content-heading {
    padding-bottom: 10px;
    border-bottom: 2px solid #00204D;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    color: #00204D;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .content-heading > span {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    text-align: right;
    color: #00204D;
  }

  .content-heading--sec {
    font-style: normal;
    font-weight: normal;
    font-size: 8px;
    line-height: 10px;
    display: flex;
    align-items: flex-end;
    color: #727984;
    padding-bottom: 10px;
    border-bottom: 2px solid #00204D;
    max-height: 20px;
    box-sizing: unset;
  }

  .logo {
    margin-right: 20px;
    width: 150px;
    height: 20px;
  }

  .logo-text {
    font-style: normal;
    font-weight: normal;
    font-size: 8px;
    line-height: 10px;
    color: #727984;
    flex: none;
    order: 1;
    flex-grow: 0;
    margin: 10px 0px;
    width: 150px;
  }

  .thumbnail {
    width: 150px;
    height: 84px;
    background: rgba(36, 49, 67, 0.1);
    margin: 20px 0;
    object-fit: cover;
  }

  .field {
    margin-bottom: 10px;
    word-break: break-word;
  }

  .page-row {
    display: flex;
  }

  .apexcharts-zoom-icon, .apexcharts-reset-icon, .apexcharts-menu-icon {
    display: none;
  }

  .apexcharts-yaxis-label {
    margin-bottom: 9px;
  }

  .heatmap-story {
    display: block;
    margin-top: 40px;
    width: 320px;
  }

  .heatmap-story-row {
    display: flex;
    align-items: center;
  }

  .heatmap-gradient {
    height: 84px;
    margin-top: 10px;
    margin-left: 20px;
  }

  .arrows {
    height: 82px;
    border-top: 1px solid;
    border-bottom: 1px solid;
    width: 20px;
    margin-top: 10px;
  }

  .more, .less {
    margin-left: 10px;
    font-style: normal;
    font-weight: bold;
    font-size: 8px;
    line-height: 11px;
    display: flex;
    align-items: flex-end;
    color: #00204D;
  }

  .more {
    margin-bottom: 60px;
  }

  .less {
    margin-bottom: -5px;
  }

  .heatmap-img {
    margin-top: 10px;
    height: 84px;
    width: 150px;
  }

  .heatmap-container {
    display: grid;
    grid-template-columns: 150px 150px 150px;
    grid-gap: 20px;
    grid-row-gap: 40px;
    flex-wrap: wrap;
  }

  .heatmap {
    flex: 1;
  }

  .no-margin-x {
    margin-left: 0;
    margin-right: 0;
  }

  .para2 {
    max-width: 170px;
    margin-left: 20px;
    margin-top: 10px;
  }

  .para {
    max-width: 150px;
    margin-top: 10px;
    word-break: break-word;
  }

  .formula-row {
    display: flex;
    align-items: flex-start;
    max-width: 150px;
  }

  .formula-row > span {
    max-width: 120px;
  }

  .formula-char {
    font-style: normal;
    font-weight: bold;
    font-size: 8px;
    line-height: 11px;
    display: flex;
    align-items: flex-end;
    color: #00204D;
    width: 20px;
  }

</style>

